import { Skeleton } from "@/components/ui/skeleton";

type Props = {
  height?: string;
};

const LoadingPage = ({ height = "200px" }: Props) => {
  return <Skeleton className={`h-[${height}] w-full`} />;
};

export default LoadingPage;
